// SectionOrchestaSlider.tsx
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import jasraj from "../../Assets/Artist/jayraj shastri  new.jpg";
import dimple from "../../Assets/Artist/Dimple Pancholi 26-09-25.png";
import himanshu from "../../Assets/Artist/Himanshu Trivedi 24-09-25.png";
import payalabhijit from "../../Assets/Artist/Payal Vakharia & Abhijit Rao 28-09-25.png";
import madhavioza from "../../Assets/Artist/Madhavi Oza 23-09-25.png";
import mayurisoni from "../../Assets/Artist/Mayuri Soni 22-09-25.png";
import yashbarot from "../../Assets/Artist/Yash Barot 01-10-25.png";
import samirraval from "../../Assets/Artist/Samir Raval 25-09-25.png";
import mihirjani from "../../Assets/Artist/Mihir Jani 29-09-25.png";
import nainasharma from "../../Assets/Artist/Naina Sharma 27-09-25.png";

interface OrchestDetail {
  date: string;
  artist: string;
  artistImage: string;
}

const OrchestList: OrchestDetail[] = [
  { date: "22 Sep", artist: "Mayuri Soni", artistImage: mayurisoni },
  { date: "23 Sep", artist: "Madhavi Oza", artistImage: madhavioza },
  { date: "24 Sep", artist: "Himanshu Trivedi", artistImage: himanshu },
  { date: "25 Sep", artist: "Samir Raval", artistImage: samirraval },
  { date: "26 Sep", artist: "Dimple Pancholi", artistImage: dimple },
  { date: "27 Sep", artist: "Naina Sharma", artistImage: nainasharma },
  { date: "28 Sep", artist: "Payal Vakhariya And Abhijeet Rao", artistImage: payalabhijit },
  { date: "29 Sep", artist: "Mihir Jani", artistImage: mihirjani },
  { date: "30 sep", artist: "Jasraj Shastri", artistImage: jasraj },
  { date: "01 Oct", artist: "Yash Barot", artistImage: yashbarot },
];

// Define your slider settings
const sliderSettings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 425,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

const SectionOrchestaSlider: React.FC = () => {
  return (
    <div className=" container mx-auto px-2 py-6">
      <div className="relative">
        <Slider {...sliderSettings}>
          {OrchestList.map((item) => (
            <div key={item.artist} className="p-4">
              <div className="bg-white p-2 rounded-lg shadow-lg">
                <div className="grid grid-cols-12 gap-4 items-center">
                  <div className="col-span-4">
                    <img
                      src={item.artistImage}
                      alt={item.artist}
                      className="w-full h-20 rounded-lg object-contain"
                    />
                  </div>
                  <div className="col-span-8">
                    <b className="text-red-600 text-sm md:text-base">
                      {item.artist}
                    </b>
                    <p className="text-xs md:text-sm">Date: {item.date}</p>
                    <p className="text-xs md:text-sm">Event: Labh-Na-Mandali-Garba</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default SectionOrchestaSlider;
